const AnimatedSliderSettings = {
  arrows: false,
  dots: false,
  infinite: true,
  slidesToShow: 2.7,
  slidesToScroll: 1,
  className: 'animatedCarouselSlider',
  initialSlide: 0,
  centerMode: true,
  autoplay: true,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1.2,
      },
    },
  ],
}

export default AnimatedSliderSettings
